import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid2 as Grid,
} from "@mui/material";
import participantService from "../services/participantService";
import Course from "../models/Course";

interface LoginFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (courseId: number | null) => void;
  selectedCourse?: Course;
  loading?: boolean;
}

interface FormErrors {
  password?: string;
  email?: string;
}

const LoginForm: React.FC<LoginFormProps> = ({
  open,
  onClose,
  onSubmit,
  selectedCourse,
  loading = false,
}) => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const [errors, setErrors] = useState<FormErrors>({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateForm = (): boolean => {
    const newErrors: FormErrors = {};

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    if (errors[name as keyof FormErrors]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
    }
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (isSubmitting || loading) return;
    if (validateForm()) {
      setIsSubmitting(true);
      participantService
        .getIfParticipantIsRegisteredForCourse(formData.email, formData.password)
        .then((result) => {
          setIsSubmitting(false)
          if (result) {
            localStorage.setItem("CurrentParticipantId", result);
            //TODO: Figure out how to handle reset course state.
            const itemsToCheck = ["user", "refreshToken", "REACT_QUERY_OFFLINE_CACHE"];
            const keys = Object.keys(localStorage)
            const difference = keys.filter(item => !itemsToCheck.includes(item));
            difference.forEach(item => {
              console.log(item)
              //window.localStorage.removeItem(item);
            })
            onSubmit(selectedCourse ? selectedCourse?.id : null)
          } else {
            //TODO: Update Errors if fail
          }
        });
    }
  };

  const lastPassIgnoreProps = {
    autoComplete: "off",
    "data-lpignore": "true",
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth scroll="body">
      <DialogTitle>Course Login for {selectedCourse?.name}</DialogTitle>
      <form onSubmit={handleSubmit} data-lpignore="true">
        <DialogContent>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 12 }}>
              <TextField
                required
                fullWidth
                name="email"
                label="Email Address"
                type="email"
                value={formData.email}
                onChange={handleChange}
                error={!!errors.email}
                helperText={errors.email}
                inputProps={lastPassIgnoreProps}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 12 }}>
              <TextField
                required
                fullWidth
                name="password"
                label="Course Password"
                type="password"
                value={formData.password}
                onChange={handleChange}
                error={!!errors.password}
                helperText={errors.password}
                inputProps={lastPassIgnoreProps}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={isSubmitting || loading}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={isSubmitting || loading}
          >
            {isSubmitting || loading ? "Accessing..." : "Access Course"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default LoginForm;
